import { Navigate } from 'react-router-dom';
import { useAuth } from '../provider/AuthProvider';

function SuperAdminRoute({ children }) {
    const { token, isSuperAdmin } = useAuth();
    const isAuthenticated = !!token;

    // Non connecté comme simple utilisateur : même destination, la racine. On ne
    // distingue pas les deux cas, inutile d'indiquer que la page existe.
    if (!isAuthenticated || !isSuperAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default SuperAdminRoute;
